import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { ProductService } from 'src/app/product/services/product.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { SharedConsts } from '../../constants';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
    selector: 'quick-add',
    templateUrl: './quick-add.component.html',
    styleUrls: ['./quick-add.component.scss'],
    standalone: false
})
export class QuickAddComponent implements OnInit {
  // public innerWidth: any;
  quickProduct: any;
  errorMessage:any;
  errorForqyt: any;
  searchWord = '';
  selectedQyt = 1;
  constants = SharedConsts
  @ViewChild('searchinput') searchinput: ElementRef;
  @ViewChild('qytchange') qytchange: ElementRef;
  @ViewChild('Addqyt') Addqyt: ElementRef;
  constructor(private quickAddService: SharedService, private productService: ProductService,
    private statePersist: StatePersistService,
    private router: Router,
    private alertService: AlertService,
    private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.quickProduct = {'qty':1, 'item_id':''};
    this.errorMessage = '';
    this.errorForqyt ='';
  }

  selectAllContent(event) {
    event.target.select();
  }

  changeValue(event){
    this.searchWord = event.target.value.trim();
    this.errorMessage = ''

  }

  qytEnter(event){
    if (event.key === "Enter" && this.errorForqyt == '') {
      this.addToCart(this.quickProduct, this.quickProduct.qty, false)
    }
  }
  quickAdd(event, direct_action){
    if ((event.key === "Enter" && this.searchWord != '') || (direct_action && this.searchWord != '')) {
      this.quickAddService.quickAdd({'search_keyword': this.searchWord})
      .subscribe(
        response => {
          if (response.status == 1177){
              this.errorMessage = response.response;
              this.quickProduct = {'qty':1, 'item_id':''};
          }
          else{
            this.quickProduct = response.response;
            if (this.quickProduct.qty == ''){
              this.quickProduct.qty = 1
            }
            this.errorMessage = '';
            
            setTimeout(() => {
              if(this.quickProduct.back_in_stock != '0'){
                this.qytchange.nativeElement.setAttribute('autofocus', 'autofocus')
                this.qytchange.nativeElement.focus();
              }
              }, 300);
            if (direct_action){
              this.addToCart(this.quickProduct, this.quickProduct.qty, false)
            }
            
          }
          },
          error => { }
      )
    }
    else if (event.key === "Enter" && this.searchWord == ''){
      this.errorMessage = ""
      // Field can't be blank
      this.quickProduct = {'qty':1, 'item_id':''};
    }
  }
  toInteger(value) {
    return parseInt(value)
  }
  addToCart(product, qyt, direct_action) {
    if (direct_action){
      this.quickAdd('', true)
    }
    else{
      this.googleAnalyticsService.eventEmitter(SharedConsts.QUICKADD_ADDTOCART_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.QUICKADD_ADDTOCART_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.qytchange.nativeElement.setAttribute('autofocus', 'autofocus')
    this.qytchange.nativeElement.focus()
    if(product.item_id !== ''){
      this.qytUpdate(product, qyt)
    }else{
    let dataObj;
    if (product.qty == '') {
      qyt = 1
    }
    dataObj = {
      "cart_item": {
        "sku": product.sku,
        "qty": qyt,
        "collect_totals":true,
      }
    }
    
    this.productService.addToCart(dataObj)
      .subscribe(
        data => {
          if (data.response) {
            if (data.status == 2212) {
              this.quickProduct['qty'] = qyt
              this.quickProduct['item_id'] = data.response.item_id
              this.quickProduct = {'qty':1, 'item_id':''};
              this.errorMessage = ''
              this.searchWord = ''
              this.searchinput.nativeElement.setAttribute('autofocus', 'autofocus')
              this.searchinput.nativeElement.focus();
              this.alertService.error(data.response.msg)
            }
            else if (data.status == 1169 || data.status == 1163) {
              this.quickProduct['qty'] = 1
              this.quickProduct['back_in_stock'] = '0'
              this.searchinput.nativeElement.blur();
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              this.quickProduct['qty'] = qyt
              this.quickProduct['item_id'] = data.response.item_id
              this.quickProduct = {'qty':1, 'item_id':''};
              this.errorMessage = ''
              this.searchWord = ''
              this.searchinput.nativeElement.setAttribute('autofocus', 'autofocus')
              this.searchinput.nativeElement.focus();
            }
            else {
              this.quickProduct['qty'] = qyt
              this.quickProduct['item_id'] = data.response.item_id
              this.quickProduct = {'qty':1, 'item_id':''};
              this.errorMessage = ''
              this.searchWord = ''
              this.searchinput.nativeElement.setAttribute('autofocus', 'autofocus')
              this.searchinput.nativeElement.focus();
            }

            this.statePersist.emitminiCartData('min cart update')
            this.statePersist.emitOrderDetailData('order details with mycart')
            this.statePersist.emitbackInStockData('back in stock')
            
            if(!this.router.url.includes('mycart')){
              this.statePersist.emitmyCartData('my cart list update')
            }
            if (this.router.url.includes('suggested')){
              this.statePersist.emitSuggestedProductListData('suggested')
            }
            let productData;
            productData = this.statePersist.getLocalStorage('product_data')
            this.statePersist.setLocalStorage('product_data', productData, 'product-data-update')

          }

        }
      );
    }
    }
    
    
    // Set boolean class on click of add button
  }

  QuickAddqytChange(event) {
    this.quickProduct['qty'] = event.target.value.trim()
    if (this.constants.NUMERIC.test(event.target.value.trim()) && (event.target.value.trim().length > 0)){
      
      if (event.target.value.trim() > 999){
        this.errorForqyt = 'Quantity not be greater then 999'
      }
      else if(event.target.value.trim() == 0){
        this.errorForqyt = 'Please enter valid number'
      }
      else{
        this.errorForqyt = ''
      }
    }

    else{
      this.errorForqyt = 'Please enter valid number'
    }
    
    
  }

  qytUpdate(product, qyt) {
    this.statePersist.amendQtyGoogleanalyticsEvent()
    this.productService.qytUpdate({ 'item_id': parseInt(product.item_id), 'qty': qyt, "collect_totals":true})
      .subscribe(
        data => {
          if (data.response) {

            if (data.status == 1169 || data.status == 1163) {
              this.quickProduct['qty'] = 1
              this.quickProduct['back_in_stock'] = '0'
              this.statePersist.emitoutOfStockData('out of stock update')
              this.searchinput.nativeElement.blur();
            }
            else if(data.status == 2212){
              this.alertService.error(data.response)
              this.quickProduct['qty'] = qyt
              this.quickProduct['item_id'] = data.response.item_id
              this.quickProduct = {'qty':1, 'item_id':''};
              this.errorMessage = ''
              this.searchWord = ''
              this.searchinput.nativeElement.setAttribute('autofocus', 'autofocus')
              this.searchinput.nativeElement.focus();
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.quickProduct = {'qty':1, 'item_id':''};
              this.errorMessage = ''
              this.searchWord = ''
              this.searchinput.nativeElement.setAttribute('autofocus', 'autofocus')
              this.searchinput.nativeElement.focus();
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              this.quickProduct['qty'] = qyt
              this.quickProduct['item_id'] = data.response.item_id
              this.quickProduct = {'qty':1, 'item_id':''};
              this.errorMessage = ''
              this.searchWord = ''
              this.searchinput.nativeElement.setAttribute('autofocus', 'autofocus')
              this.searchinput.nativeElement.focus();
            }
            else {
              this.quickProduct['qty'] = qyt
              this.quickProduct = {'qty':1, 'item_id':''};
              this.errorMessage = ''
              this.searchWord = ''
              if(this.quickProduct.back_in_stock != '0'){
                this.searchinput.nativeElement.setAttribute('autofocus', 'autofocus')
                this.searchinput.nativeElement.focus();
              }
                
              
            }
            
            this.statePersist.emitminiCartData('min cart update')
            this.statePersist.emitOrderDetailData('order details with mycart')
            this.statePersist.emitbackInStockData('back in stock')
            if(!this.router.url.includes('mycart')){
              this.statePersist.emitmyCartData('my cart list update')
            }
            let productData;
            productData = this.statePersist.getLocalStorage('product_data')
            this.statePersist.setLocalStorage('product_data', productData, 'product-data-update')

          }

        }
      );
     
  }

}
